import React, { useContext, useState } from 'react';
import {
    Platform,
    SafeAreaView,
    View,
    FlatList,
    StyleSheet,
} from 'react-native';
import { useTheme } from '@react-navigation/native';
import { useTranslation } from 'react-i18next';

import { createCommonStyles } from '../../../styles/commonStyles';
import CustomLabel from '../../../components/CustomLabel/CustomLabel';
import CustomButton from '../../../components/CustomButton';
import RoleGuard from '../../../components/RoleGuard';
import { HRAdminCompanyContext } from '../../../context/HRAdminCompanyContext';
import { TASKS, TASK_OPTIONS } from '../../../constants/Tasks';

import EmployeesAnalyticsSection from '../HRAdminAnalytics/EmployeesAnalyticsSection';
import LeavesAnalyticsSection from '../HRAdminAnalytics/LeavesAnalyticsSection';

const buttonTable = [0, 1];

const HRAdminPageAnalytics = () => {
    const { t } = useTranslation();
    const { colors } = useTheme();
    const common = createCommonStyles(colors);
    const styles = createStyles(colors);

    const { selectedCompanyCode } = useContext(HRAdminCompanyContext);

    const [activeTab, setActiveTab] = useState(null);
    const [TEST1, setTEST1] = useState(false);

    const toggleTab = (tab) => {
        setActiveTab((prev) => (prev === tab ? null : tab));
    };

    const hasSelectedCompany = !!selectedCompanyCode;

    return (
        <SafeAreaView style={{ flex: 1, backgroundColor: colors.background }}>
            <CustomLabel value={t('navigate:hrAdminAnalytics')} type="MINORTITLE" />
            <View style={common.divider} />

            <View>
                <FlatList
                    horizontal
                    showsHorizontalScrollIndicator
                    directionalLockEnabled
                    alwaysBounceVertical={false}
                    data={buttonTable}
                    contentContainerStyle={styles.tabsContainer}
                    showsVerticalScrollIndicator
                    keyExtractor={(item) => `${item}`}
                    renderItem={({ index }) => (
                        <SafeAreaView>
                            {index === 0 && (
                                <RoleGuard
                                    parentTask={TASKS.ANALYTICS}
                                    task={TASK_OPTIONS.ANALYTICS_EMPLOYEES}
                                    table="hr"
                                    requireCRUD
                                >
                                    <CustomButton
                                        onPress={() => toggleTab('employees')}
                                        text={t('navigate:employees')}
                                        iconName="people-outline"
                                        show={activeTab === 'employees' ? 'HOME_SELECTED' : 'HOME'}
                                        type={activeTab === 'employees' ? 'HOME_SELECTED' : 'HOME'}
                                        textTop="0"
                                        isGradient={activeTab === 'employees'}
                                        sz={Platform.OS !== 'web' ? 20 : 25}
                                    />
                                </RoleGuard>
                            )}

                            {index === 1 && (
                                <RoleGuard
                                    parentTask={TASKS.ANALYTICS}
                                    task={TASK_OPTIONS.ANALYTICS_LEAVES}
                                    table="hr"
                                    requireCRUD
                                >
                                    <CustomButton
                                        onPress={() => toggleTab('leaves')}
                                        text={t('navigate:leaves')}
                                        iconName="layers-outline"
                                        show={activeTab === 'leaves' ? 'HOME_SELECTED' : 'HOME'}
                                        type={activeTab === 'leaves' ? 'HOME_SELECTED' : 'HOME'}
                                        textTop="0"
                                        isGradient={activeTab === 'leaves'}
                                        sz={Platform.OS !== 'web' ? 20 : 25}
                                    />
                                </RoleGuard>
                            )}
                        </SafeAreaView>
                    )}
                />
            </View>

            {!hasSelectedCompany ? (
                <View style={styles.emptyStateWrapper}>
                    <View style={styles.emptyStateCard}>
                        <View style={styles.textBlock}>
                            <CustomLabel
                                value={t('hrAdmin:selectCompanyTitle', 'No company selected')}
                                type="TITLE"
                            />
                        </View>

                        <View style={styles.spacing} />

                        <View style={styles.textBlock}>
                            <CustomLabel
                                value={t(
                                    'hrAdmin:selectCompanyMessage',
                                    'Please select a company to view the analytics dashboards.'
                                )}
                                type="BODY"
                            />
                        </View>
                    </View>
                </View>
            ) : (
                <>
                    {activeTab === 'employees' && (
                        <EmployeesAnalyticsSection selectedCompanyCode={selectedCompanyCode} />
                    )}

                    {activeTab === 'leaves' && (
                        <LeavesAnalyticsSection selectedCompanyCode={selectedCompanyCode} />
                    )}
                </>
            )}
        </SafeAreaView>
    );
};

const createStyles = (colors) =>
    StyleSheet.create({
        tabsContainer: {
            alignSelf: 'flex-start',
            marginBottom: '1%',
        },
        emptyStateWrapper: {
            flex: 1,
            paddingHorizontal: 16,
            paddingTop: 16,
            paddingBottom: 24,
        },
        emptyStateCard: {
            flex: 1,
            borderRadius: 16,
            borderWidth: 1,
            borderColor: colors.border,
            backgroundColor: colors.card,
            justifyContent: 'center',
            alignItems: 'center',
            paddingHorizontal: 24,
            paddingVertical: 32,
        },
        textBlock: {
            alignItems: 'center',
        },
        spacing: {
            height: 10,
        },
    });

export default HRAdminPageAnalytics;